import React from "react";
import { Redirect } from "react-router-dom";
import { accountService } from "services";
import { fetchWrapper } from "data/FetchWrapper";

const Logout = () => {
  fetchWrapper.post(`/api/user/logout`);
  accountService.logout();
  return <Redirect to={{ pathname: "/account/login" }} />;
};

export { Logout };
